import { FreeCamera } from '@babylonjs/core/Cameras/freeCamera'
import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import type { Scene } from '@babylonjs/core/scene'
import type { PlayerState } from '../contracts/game'

export class ChaseCameraController {
  public readonly camera: FreeCamera
  private readonly target = new Vector3()
  private smoothedX = 0
  private smoothedY = 7
  private smoothedZ = -14

  public constructor(scene: Scene) {
    this.camera = new FreeCamera('chase-camera', new Vector3(0, 7, -14), scene)
    this.camera.minZ = 0.1
    this.camera.maxZ = 520
    this.camera.fov = 65 * Math.PI / 180
    scene.activeCamera = this.camera
  }

  public update(
    player: Readonly<PlayerState>,
    renderOriginZ: number,
    deltaSeconds: number,
    speedNormalized: number,
    reducedMotion: boolean,
  ): void {
    const followDistance = 14 + speedNormalized * 5
    const desiredX = player.position.x * 0.72
    const desiredY = player.position.y + 6.2 - speedNormalized * 0.9
    const desiredZ = player.position.z - renderOriginZ - followDistance
    const positionDamping = 1 - Math.exp(-deltaSeconds * 7.5)
    this.smoothedX += (desiredX - this.smoothedX) * positionDamping
    this.smoothedY += (desiredY - this.smoothedY) * (1 - Math.exp(-deltaSeconds * 5.5))
    this.smoothedZ += (desiredZ - this.smoothedZ) * positionDamping
    this.camera.position.set(this.smoothedX, this.smoothedY, this.smoothedZ)
    this.target.set(player.position.x * 0.22, player.position.y + 0.3, player.position.z - renderOriginZ + 11)
    this.camera.setTarget(this.target)
    const targetFov = (reducedMotion ? 65 : 65 + speedNormalized * 17) * Math.PI / 180
    this.camera.fov += (targetFov - this.camera.fov) * (1 - Math.exp(-deltaSeconds * 4))
  }

  public snap(player: Readonly<PlayerState>, renderOriginZ: number): void {
    this.smoothedX = player.position.x * 0.72
    this.smoothedY = player.position.y + 6.2
    this.smoothedZ = player.position.z - renderOriginZ - 14
    this.camera.position.set(this.smoothedX, this.smoothedY, this.smoothedZ)
  }

  public updateMenu(timeSeconds: number): void {
    const angle = timeSeconds * 0.12
    this.camera.position.set(Math.sin(angle) * 5.8, 3.7 + Math.sin(timeSeconds * 0.3) * 0.35, -8.2 + Math.cos(angle) * 1.8)
    this.target.set(0, 1.1, 2.5)
    this.camera.setTarget(this.target)
    this.camera.fov = 58 * Math.PI / 180
  }
}
